import { Controller } from '@hotwired/stimulus';

// Liste : la recherche en cours (champ q du tableau, envoyé
// dans la Frame des lignes, donc absent des liens rendus avec la page) est
// reprise par les pastilles de la barre, celles de la table et celles de la
// page (sync : leurs adresses suivent la frappe, liens ordinaires) et par la
// barre de filtres (addSearch, à l'envoi).
const currentSearch = () => document.querySelector('form[role=search] input[name=q]')?.value.trim() || '';

export default class extends Controller {
    sync() {
        const search = currentSearch();
        this.element.querySelectorAll('nav a[href]').forEach((link) => {
            const url = new URL(link.href, window.location.href);
            if (search) url.searchParams.set('q', search); else url.searchParams.delete('q');
            link.setAttribute('href', url.pathname + url.search);
        });
    }

    addSearch() {
        this.element.querySelector('input[type=hidden][name=q]')?.remove();
        const search = currentSearch();
        if (!search) return;
        const input = document.createElement('input');
        Object.assign(input, { type: 'hidden', name: 'q', value: search });
        this.element.append(input);
    }
}
